export function validate(values, schema: Record<string, unknown> = {}) {
  return Object.entries(schema).reduce((errors, [key, validations]) => {
    const validationsArr = !Array.isArray(validations)
      ? [validations]
      : validations

    for (let i = 0; i < validationsArr.length; i++) {
      if (!validationsArr[i].fn(values[key], validationsArr[i].compareValue)) {
        errors[key] = validationsArr[i].errorText
        break
      }
    }
    return errors
  }, {})
}
